import React, { useState } from "react";
import s from "./tabs.module.scss";
import classNames from "classnames";

export const Tab = ({children}) =>  children

export const Tabs = ({ options, children, className, defaultTab, onChange }) => {
  const [mode, setMode] = useState(defaultTab ? defaultTab : 0);

	const updateMode = (num) => {
		setMode(num)
		onChange?.(num)
	}

  return (
    <>
      <div
        className={classNames(s.tabs, className)}
        style={{ "--count": options?.length, "--current": mode }}
      >
        {options?.map((el, index) => (
          <button
            key={"tab-button-" + el?.key}
            className={classNames(s.tab, mode === index ? s.active : "")}
            onClick={() => updateMode(index)}
          >
            {el.label}
          </button>
        ))}
      </div>
			<div className={s.slide}>
				{[...children][mode]}
			</div>
    </>
  );
};
